import { ScreenRouteGuard } from '@/app/shell/screen-route-guard';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireAuth } from '@/app/auth';
import { AuthenticatedShell } from '@/app/shell/authenticated-shell';
import { ensureEffectivePermissions } from '@/shared/permissions';

export const Route = createFileRoute('/_app')({
  beforeLoad: async (ctx) => {
    const { auth } = await requireAuth(ctx);
    await ensureEffectivePermissions(ctx.context.queryClient);
    return { auth };
  },
  component: () => (
    <AuthenticatedShell>
      <ScreenRouteGuard>
        <Outlet />
      </ScreenRouteGuard>
    </AuthenticatedShell>
  ),
});
